export const CARD_HEADER_CONTAINER_CLASS =
  "sb-account-settings-card-header-container";
export const CARD_HEADER_TITLE_CLASS = "sb-account-settings-card-title";

export const CARD_INPUT_LABEL_CLASS =
  "sb-account-settings-input-label sb-shrink-0 md:sb-block";
export const CARD_INPUT_FIELD_CLASS =
  "sb-account-settings-input-field sb-border-none !sb-shadow-none disabled:!sb-opacity-100";
export const CARD_CONTAINER_CLASS = "sb-account-settings-card-container";
export const CARD_EDITABLE_INPUT_CLASS = "sb-account-settings-card-edit-input";
export const CARD_DEFAULT_BUTTON = "sb-account-settings-card-button-full";
export const CARD_OUTLINE_BUTTON = "sb-account-settings-card-button-full";
export const CARD_EDIT_BUTTON =
  "sb-account-settings-card-edit-button sb-text-muted-foreground sb-flex sb-items-center";
